<template>
	<div class="card">
		<header class="card-header language-list">
			<h3 class="card-title">Labels</h3>
		</header>
		<div class="card-body">
			<section>
				<div class="input-group">

					<vue-select
							label="name"
							:options="filteredAllLabels"
							taggable
							v-model="selectedLabel"
					>
					</vue-select>
					<a class="btn btn-primary" @click="addLabel">Add</a>
				</div>
			</section>
			<section>
				<ul class="tag-cloud">
					<li v-for="(label, index) in labels.attachedLabels">{{label.name}}
						<span @click="detachLabel(index)" title="detach label">×</span></li>
				</ul>
			</section>
		</div>
	</div>
</template>

<script>
	import VueSelect from '../../../../node_modules/vue-select';

	export default {
		components: {
			"vue-select": VueSelect,
		},
		props: {
			articleId: {
				type: Number
			},
			labels: {
				type: Object
			}
		},
		data() {
			return {
				recalc: 0,
				userRoles: this.$currentUserRoles,
				selectedLabel: {
					name: null,
				},
			}
		},
		computed: {
			filteredAllLabels: function () {
				let vm = this;
				let filtered = [];
				this.labels.allLabels.forEach(function (label) {
					let check = false;
					if (vm.labels.attachedLabels.some(attachedLabel => attachedLabel.name.toLowerCase() === label.name.toLowerCase())) {
						check = true;
					}
					if (check !== true) {
						filtered.push(label);
					}
				});
				return filtered;
			}
		},
		watch: {
			selectedLabel: function () {
				if (typeof this.selectedLabel !== 'object' && typeof this.selectedLabel === 'string') {
					this.resetSelectedLabels(this.selectedLabel);
				}
			},
		},
		methods: {

			resetSelectedLabels: function (name = null) {
				this.selectedLabel = {
					name: name,
				};
			},
			addLabel: function () {
				if (!this.selectedLabel.hasOwnProperty('id')) {
					this.createLabel();
				} else {
					this.labels['attachedLabels'].push(this.selectedLabel);
					this.getAllLabels();
					this.resetSelectedLabels();
				} // if
			},
			createLabel: function () {
				let vm = this;
				let check = true;

				if (this.labels.allLabels.some(label => label.name.toLowerCase() === this.selectedLabel.name.toLowerCase())) {
					check = false;
				} // if

				if (check === false) {
					this.$toastr.error('Label already exists', 'Error');
					return true;
				} // if

				axios.post('/api/' + vm.$selectedSite.slug + '/labels/create', {label: vm.selectedLabel},
				).then(function (response) {
					vm.selectedLabel = response.data.label;
					vm.addLabel();
				}).catch(function (e) {
					vm.errors.record(e.response.data);
				});
			},
			getAllLabels: function () {
				let vm = this;
				axios.get('/api/' + vm.$selectedSite.slug + '/labels/getall'
				).then(function (response) {
					vm.labels.allLabels = response.data.labels;
				}).catch(function (e) {
					vm.errors.record(e.response.data);
				});
			},
			detachLabel: function (index) {
				this.$delete(this.labels.attachedLabels, index);
			}
		}
	}
</script>

<style scoped>

</style>
